import { clientEnv, runtimeEnvironment } from '@/lib/env';

export function resolveSentryEnvironment(
  configuredEnvironment = clientEnv.NEXT_PUBLIC_SENTRY_ENVIRONMENT,
  nodeEnvironment = runtimeEnvironment
) {
  if (configuredEnvironment) {
    return configuredEnvironment;
  }

  if (nodeEnvironment === 'development') {
    return 'local';
  }

  return nodeEnvironment || 'development';
}

export function resolveSentryRelease() {
  return clientEnv.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || undefined;
}
